if (!customElements.get("collection-paginate-v2")) {
  customElements.define(
    "collection-paginate-v2",
    class CollectionPaginateV2 extends HTMLElement {
      constructor() {
        super();

        this.productGrid = this.querySelector("#product-grid");
        this.currentPage = parseInt(this.dataset.pageNum);
        this.totalPages = parseInt(this.dataset.pageTotal);
        this.inProgress = false;

        this.init();
      }

      init() {
        this.initPaginationButtons();
      }

      initPaginationButtons() {
        const prevButton = this.querySelector('.pagination-prev');
        const nextButton = this.querySelector('.pagination-next');
        const pageButtons = this.querySelectorAll('.pagination-page');

        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (!this.inProgress && this.currentPage > 1) {
              this.navigateToPage(this.currentPage - 1);
            }
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (!this.inProgress && this.currentPage < this.totalPages) {
              this.navigateToPage(this.currentPage + 1);
            }
          });
        }

        if (pageButtons) {
          pageButtons.forEach(button => {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              const pageNum = parseInt(button.dataset.page);
              if (!this.inProgress && pageNum !== this.currentPage) {
                this.navigateToPage(pageNum);
              }
            });
          });
        }
      }

      updatePaginationUI() {
        const prevButton = this.querySelector('.pagination-prev');
        const nextButton = this.querySelector('.pagination-next');
        const pageButtons = this.querySelectorAll('.pagination-page');

        if (prevButton) {
          prevButton.classList.toggle('disabled', this.currentPage <= 1);
        }

        if (nextButton) {
          nextButton.classList.toggle('disabled', this.currentPage >= this.totalPages);
        }

        if (pageButtons) {
          pageButtons.forEach(button => {
            const pageNum = parseInt(button.dataset.page);
            button.classList.toggle('active', pageNum === this.currentPage);
          });
        }
      }

      async navigateToPage(pageNum) {
        if (this.inProgress) return;
        
        try {
          this.inProgress = true;
          this.productGrid.classList.add('loading');

          // Get the collection page data
          const data = await fetch(`${window.location.pathname}?page=${pageNum}`).then(
            (response) => response.text()
          );
          
          const paginateHTML = document.createElement("div");
          paginateHTML.innerHTML = data;
          const newCollData = paginateHTML.querySelector("collection-paginate-v2");

          // Update the product grid
          this.productGrid.innerHTML = newCollData.productGrid.innerHTML;

          // Update pagination
          this.currentPage = pageNum;
          this.updatePaginationUI();

          // Update URL without page reload
          const url = new URL(window.location);
          url.searchParams.set('page', pageNum);
          window.history.pushState({}, '', url);

          // Scroll to top of page
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (err) {
          console.error('Error loading page:', err);
        } finally {
          this.inProgress = false;
          this.productGrid.classList.remove('loading');
        }
      }
    }
  );
}
